// This solution was fount on http://beej.us/blog/data/javascript-gamepad/
/**
 * Clamp the joystick coords at length 1.0
 */
export default function clampStick(x, y) {
    // Compute magnitude (length) of vector
    let magnitude = Math.sqrt(x * x + y * y);

    // If the length greater than 1, normalize it (set it to 1)
    if (magnitude > 1) {
        x /= magnitude;
        y /= magnitude;
    }

    // Return the (possibly normalized) vector
    return [x, y];

}